module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/video-55974c2828a84be03787c18295a7a3a1.svg";